import { render, staticRenderFns } from "./agreementDeclaration.vue?vue&type=template&id=be181f7e&scoped=true&"
import script from "./agreementDeclaration.vue?vue&type=script&lang=js&"
export * from "./agreementDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./agreementDeclaration.vue?vue&type=style&index=0&id=be181f7e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be181f7e",
  null
  
)

export default component.exports